import React, { useRef } from 'react';
import TruncateTextCmp from 'src/components/TruncateText';

import { SHARE_MOBILE_ROW_TEXT } from './shareMobile.styles';

interface IProps {
    label: string;
    value?: string;
    valueHtml?: string;
    icon?: React.ReactNode;
    isLoading?: boolean;
    align?: 'center' | 'start';
    isLabelLoading?: boolean;
    // Share-link mobile sheet: label + value both in text-tertiary per Figma.
    isShareMobile?: boolean;
}

const InfoRow: React.FC<IProps> = ({ label, value, valueHtml, icon, isLoading = false, align = 'center', isLabelLoading = false, isShareMobile = false }) => {
    const valueRef = useRef<HTMLParagraphElement>(null);
    const displayValue = isLoading ? 'lorem ipsum dolor' : value ?? '-';
    // Share sheet: multi-line rows (address / instructions, align="start") wrap instead of truncating.
    const isWrapping = isShareMobile && align === 'start' && !isLoading;
    const valueClassName = `text-xs leading-[18px] font-medium text-textSecondary text-right ${isWrapping ? 'whitespace-normal break-words' : 'truncate'} ${
        isShareMobile ? SHARE_MOBILE_ROW_TEXT : ''
    }`;

    return (
        <div className={`flex ${align === 'start' ? 'items-start' : 'items-center'} justify-between gap-x-4`}>
            <p className={`text-xs leading-[18px] text-textSecondary font-normal flex-none ${isLabelLoading ? 'custom-loading' : ''} ${isShareMobile ? SHARE_MOBILE_ROW_TEXT : ''}`}>
                {isLabelLoading ? 'lorem ipsum dolor' : label}
            </p>
            <div className={`flex items-center gap-x-1.5 min-w-0 ${isLoading ? 'custom-loading' : ''}`}>
                {!isLoading && icon}
                <TruncateTextCmp message={value ?? '-'} refName={valueRef}>
                    {!isLoading && valueHtml ? (
                        <p ref={valueRef} className={valueClassName} dangerouslySetInnerHTML={{ __html: valueHtml }} />
                    ) : (
                        <p ref={valueRef} className={valueClassName}>
                            {displayValue}
                        </p>
                    )}
                </TruncateTextCmp>
            </div>
        </div>
    );
};

export default InfoRow;
